import { render, staticRenderFns } from "./footwear.vue?vue&type=template&id=194f3ec8"
import script from "./footwear.vue?vue&type=script&lang=js"
export * from "./footwear.vue?vue&type=script&lang=js"
import style0 from "./footwear.vue?vue&type=style&index=0&id=194f3ec8&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/Resourced/Resourced/Frontend-old/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('194f3ec8')) {
      api.createRecord('194f3ec8', component.options)
    } else {
      api.reload('194f3ec8', component.options)
    }
    module.hot.accept("./footwear.vue?vue&type=template&id=194f3ec8", function () {
      api.rerender('194f3ec8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "public/pages/suppliers/footwear.vue"
export default component.exports